export const environment = {
  production: false,
  appConfig: 'config.json', // Adjust the file name/path as needed
}
